import { Stack } from '@mui/material';
import { CPTextField } from './CPTextField';
import { useTranslation } from 'react-i18next';

interface UserNameInputProps {
  firstname: string;
  lastname: string;
  onFirstnameChange: (firstname: string) => void;
  onLastnameChange: (lastname: string) => void;
  className?: string;
}

export const UserNameInput = ({
  className = "",
  ...props
}: UserNameInputProps) => {
  const [t] = useTranslation();

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      className={className}
      spacing={{ xs: 3, sm: 2 }}
    >
      <CPTextField
        id="firstname"
        label={t('user_update.text.firstname')}
        value={props.firstname}
        type="text"
        autoFocus={false}
        onChange={props.onFirstnameChange}
      />

      <CPTextField
        id="lastname"
        label={t('user_update.text.lastname')}
        value={props.lastname}
        type="text"
        autoFocus={false}
        onChange={props.onLastnameChange}
      />
    </Stack>
  );
};
